import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";

export default class Sink extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_sink';
    this.partName = 'Sink';
    this.translateId = "visualizer.kitchen.center_island.center_island_sink";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    // dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    if (dbFeature.s3Bindings && dbFeature.metaData && (!dbFeature.metaData["Placement"]
      || !dbFeature.metaData["Placement"].includes(PLACEMENTS.Island))) {
      return false
    }
    return super.load_(dbFeature, new Sink());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    const relatedFaucet = centerIslandParent.faucet;
    if (relatedFaucet) {
      relatedFaucet.disabled = this.disabled;
    }
    const stovetop = centerIslandParent.stovetop;
    if (stovetop && !this.disabled && !stovetop.disabled) {
      stovetop.disabled = true;
    }
    const range = centerIslandParent.range;
    if (range && !this.disabled && !range.disabled) {
      range.disabled = true;
    }
  }
}
